import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";
import { IWiki } from "@/@types/wikimap/wiki";

interface IWikiState {
  activeList: Array<IWiki>;
}

const state = (): IWikiState => ({
  activeList: [],
});

const getters: _GettersTree<IWikiState> = {
  wikiDots: (state: IWikiState): Array<IWiki> => state.activeList,
};

export const wiki: StoreDefinition<
  string,
  IWikiState,
  _GettersTree<IWikiState>,
  _ActionsTree
> = defineStore<string, IWikiState>("wiki", {
  state,
  getters,
  actions: {
    setWikiDots(dots: Array<IWiki> | undefined) {
      if (!dots) return;
      this.activeList = dots;
    },
  },
});
